import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";

interface monthlyExpensesProps {
  data?: any;
}

const MonthlyExpensesView: React.FC<monthlyExpensesProps> = ({ data }) => {
  return (
    <div className="container mt-4">
      <div className="row">
        {/* Row 1 */}
        <ReadonlyField label="Monthly Rent" value={`SAR | ${data?.monthlyRent || 0}`} />
        <ReadonlyField
          label="Household Wage"
          value={`SAR | ${data?.householdWage || 0}`}
        />
        <ReadonlyField
          label="Utility Expense"
          value={`SAR | ${data?.utilityExpense || 0}`}
        />
        <ReadonlyField
          label="Insurance Premium"
          value={`SAR | ${data?.insurancePremium || 0}`}
        />
        {/* Row 2 */}
        <ReadonlyField
          label="Transport Expenses"
          value={`SAR | ${data?.transportExpenses || 0}`}
        />
        <ReadonlyField
          label="Healthcare Expenses"
          value={`SAR | ${data?.healthcareExpenses || 0}`}
        />
        <ReadonlyField
          label="Communication Expenses"
          value={`SAR | ${data?.communicationExpenses || 0}`}
        />
        <ReadonlyField
          label="Food and living expenses"
          value={`SAR | ${data?.foodAndLivingExpenses || 0}`}
        />

        {/* Row 3 */}
        <ReadonlyField
          label="Expat Dependency  Gov fees"
          value={`SAR | ${data?.expatDependent || 0}`}
        />
        <ReadonlyField
          label="Education Supplies Expense"
          value={`SAR | ${data?.educationSuppliesExpense || 0}`}
        />
        <ReadonlyField
          label="Monthly Remittance"
          value={`SAR | ${data?.monthlyRemittance || 0}`}
        />
        <ReadonlyField
          label="Other Monthly Expenses"
          value={`SAR | ${data?.otherMonthlyExpenses || 0}`}
        />
      </div>
    </div>
  );
};

export default memo(MonthlyExpensesView);
